import { Component, ViewChild, ViewContainerRef, AfterViewInit, ElementRef } from '@angular/core';

import { SliderComponent } from "./components/slider/slider.component";
import { HeaderComponent } from "./components/header/header.component";
import { WorksComponent } from "./containers/works/works.component";
import { ProjectsComponent } from "./containers/projects/projects.component";
import { BioComponent } from "./components/bio/bio.component";
import { BlurFadeDirective } from "./utils/directives/blur-fade.directive";

@Component({
  selector: 'app-body',
  standalone: true,
  imports: [
    SliderComponent,
    HeaderComponent,
    WorksComponent,
    ProjectsComponent,
    BioComponent,
    BlurFadeDirective
  ],
  templateUrl: './body.component.html',
  styleUrl: './body.component.scss'
})
export class BodyComponent implements AfterViewInit {
  @ViewChild("worksContainer", { read: ViewContainerRef }) worksContainer!: ViewContainerRef;
  @ViewChild("projectsContainer", { read: ViewContainerRef }) projectsContainer!: ViewContainerRef;

  @ViewChild("worksContainer", { read: ElementRef }) worksElement!: ElementRef;
  @ViewChild("projectsContainer", { read: ElementRef }) projectsElement!: ElementRef;

  ngAfterViewInit(): void {
    this.observeSections();
  }

  private observeSections(): void {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          if (entry.target.id === "worksSection" && this.worksContainer.length === 0) {
            const { WorksComponent } = await import("../body/containers/works/works.component");
            this.worksContainer.createComponent(WorksComponent);
          }
          if (entry.target.id === "projectsSection" && this.projectsContainer.length === 0) {
            const { ProjectsComponent } = await import("../body/containers/projects/projects.component");
            this.projectsContainer.createComponent(ProjectsComponent);
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    observer.observe(this.worksElement.nativeElement);
    observer.observe(this.projectsElement.nativeElement);
  }
}
